<template>
  <b-overlay :show="busy">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" sm="8" lg="5">

          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Create Free Account</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="div-section-body">

            <b-form @submit.stop.prevent="register">
              <b-row>
                <b-col cols="12">
                  <div class="px-2">

                    <!-- JobTitle -->
                    <b-form-group label="Position" label-for="position" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="position" placeholder="-- select one --" v-model.trim="$v.form.jobTitle.$model" :options="lists.jobTitles" :state="validateState('jobTitle')" aria-describedby="support-position-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-position-feedback">Select position.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- AGD Number -->
                    <b-form-group label="AGD Member Number (optional)" label-for="zip" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="agdnumber"
                          v-model="$v.form.agdNumber.$model"
                          type="text"
                          placeholder="AGD Member Number"
                          :state="validateState('agdNumber')"
                          aria-describedby="support-agdnumber-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.form.agdNumber.optionalAgdNumber">Leave blank or enter valid value.</b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.form.agdNumber.optionalAgdNumberDupe">AGD Number already in use.  Choose another.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Salutation -->
                    <b-form-group label="Title" label-for="title" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="title" placeholder="" v-model.trim="$v.form.title.$model" :options="lists.titles" :state="validateState('title')" aria-describedby="support-title-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-title-feedback">Select title.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- First Name -->
                    <b-form-group label="First Name" label-for="firstname" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="firstname"
                          v-model.trim="$v.form.firstname.$model"
                          type="text"
                          placeholder="Your first name"
                          :state="validateState('firstname')"
                          aria-describedby="support-firstname-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-firstname-feedback">First name is a required field and must be at least 3 characters.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Last Name -->
                    <b-form-group label="Last Name" label-for="lastname" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="lastname"
                          v-model.trim="$v.form.lastname.$model"
                          type="text"
                          placeholder="Your last name"
                          :state="validateState('lastname')"
                          aria-describedby="support-lastname-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-lastname-feedback">Last name is a required field and must be at least 3 characters.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Office -->
                    <b-form-group label="Practice Name" label-for="officeName" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="officeName"
                          v-model.trim="$v.form.officeName.$model"
                          type="text"
                          placeholder="Your practice name"
                          :state="validateState('officeName')"
                          aria-describedby="support-officeName-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-officeName-feedback">This is a required field and must be at least 3 characters.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Address -->
                    <b-form-group label="Address" label-for="address" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="address"
                          v-model="$v.form.address.$model"
                          type="text"
                          placeholder="Your address"
                          :state="validateState('address')"
                          aria-describedby="support-address-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-address-feedback">Address is required field.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- City -->
                    <b-form-group label="City" label-for="city" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="city"
                          v-model.trim="$v.form.city.$model"
                          type="text"
                          placeholder="Your city"
                          :state="validateState('city')"
                          aria-describedby="support-city-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-city-feedback">City is a required field.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- State -->
                    <b-form-group label="State" label-for="state" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="state" placeholder="" v-model="$v.form.state.$model" :options="lists.states" :state="validateState('state')" aria-describedby="support-state-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-position-feedback">Select state.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Zip -->
                    <b-form-group label="Zip/Postal Code" label-for="zip" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="zip"
                          v-model.trim="$v.form.zip.$model"
                          type="text"
                          placeholder="Your zip/postal code"
                          :state="validateState('zip')"
                          aria-describedby="support-zip-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-zip-feedback">Zip/Postal Code is required field.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Country -->
                    <b-form-group label="Country" label-for="country" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="country" placeholder="" v-model="$v.form.country.$model" :options="lists.countries" :state="validateState('country')" aria-describedby="support-country-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-position-feedback">Select country.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Phone -->
                    <b-form-group label="Phone" label-for="phone" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="phone"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          id="phone"
                          v-model.trim="$v.form.phone.$model"
                          type="tel"
                          placeholder="Your phone number"
                          :state="validateState('phone')"
                          aria-describedby="support-phone-feedback"
                        ></b-form-input>
                        &nbsp;&nbsp;
                        <b-form-checkbox
                          id="isphonemobile"
                          v-model="isPhoneMobile"
                          value="checked"
                          unchecked-value="unchecked"
                          class="mt-2"
                        >
                          Is Mobile
                        </b-form-checkbox>
                        <b-form-invalid-feedback id="support-phone-feedback">Phone number is required.</b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>

                    <!-- Email -->
                    <b-form-group label="Email" label-for="email" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="envelope"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          id="email"
                          v-model.trim.lazy="$v.form.email.$model"
                          type="email"
                          placeholder="Your work email address"
                          :state="validateState('email')"
                          aria-describedby="support-email-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback v-if="!$v.form.email.required">Email is required.</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.form.email.email">Enter valid email address.</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.form.email.isValid">Email already in use. Choose another.</b-form-invalid-feedback>
                        <!-- <b-form-invalid-feedback id="support-email-feedback">Work email address is required.</b-form-invalid-feedback> -->
                      </b-input-group>
                    </b-form-group>

                    <!-- Username -->
                    <b-form-group label="Username" label-for="username" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="person"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          id="username"
                          v-model.trim.lazy="$v.form.username.$model"
                          type="text"
                          placeholder="Account username"
                          :state="validateState('username')"
                          aria-describedby="support-username-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback v-if="!$v.form.username.required">Username is required.</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.form.username.minLength">Username has minimum length.</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.form.username.isValid">This username is not available. Choose another.</b-form-invalid-feedback>
                        <!-- <b-form-invalid-feedback id="support-username-feedback">Unique username is required.</b-form-invalid-feedback> -->
                      </b-input-group>
                    </b-form-group>

                    <!-- Password -->
                    <b-form-group label="Password" label-for="password" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                        <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="lock"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                            id="password"
                            v-model.trim="$v.form.password.$model"
                            type="password"
                            placeholder="Password"
                            :state="validateState('password')"
                            aria-describedby="support-password-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback v-if="!$v.form.password.required">Password is required.</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.form.password.minLength">Password must be 6 characters or longer.</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.form.password.regexPwd">Invalid character(s) detected.</b-form-invalid-feedback>
                        <!-- <b-form-invalid-feedback id="support-password-feedback">Password is required.</b-form-invalid-feedback> -->
                        </b-input-group>
                    </b-form-group>

                    <!-- Password retype -->
                    <b-form-group label="Password (retype)" label-for="password2" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                        <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="lock"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                            id="password2"
                            v-model.trim="$v.form.password2.$model"
                            type="password"
                            placeholder="Password (retype)"
                            :state="validateState('password2')"
                            aria-describedby="support-password2-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="support-password2-feedback">Passwords must match.</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>

                    <!-- Cert Year -->
                    <b-form-group label="Graduation Year" label-for="certyear" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="certyear" placeholder="" v-model="$v.form.certYear.$model" :options="lists.certYears" :state="validateState('certYear')" aria-describedby="support-certyear-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-certyear-feedback">Select one.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Gender -->
                    <b-form-group label="Gender" label-for="gender" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-input-group class="mb-2">
                        <b-form-radio-group
                          id="gender"
                          name="gender"
                          v-model="$v.form.gender.$model"
                          :options="lists.genders"
                          buttons
                          button-variant="info"
                          aria-describedby="support-gender-feedback"
                        ></b-form-radio-group>
                        <b-input-group-append is-text>
                          <!-- <b-icon icon="envelope"></b-icon> -->
                          {{viewGender}}
                        </b-input-group-append>
                        <b-form-invalid-feedback id="support-gender-feedback">Required field.</b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>

                    <!-- Age Range -->
                    <b-form-group label="Age Range" label-for="agerange" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="agerange" placeholder="" v-model="$v.form.ageRange.$model" :options="lists.ageRanges" :state="validateState('ageRange')" aria-describedby="support-agerange-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-agerange-feedback">Select one.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Office Size -->
                    <b-form-group label="Office Size" label-for="officesize" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="officesize" placeholder="" v-model="$v.form.officeSize.$model" :options="lists.officeSizes" :state="validateState('officeSize')" aria-describedby="support-officesize-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-officesize-feedback">Select one.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Source -->
                    <b-form-group label="Referred By" label-for="sourceheard" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="sourceheard" placeholder="" v-model="$v.form.sourceHeard.$model" :options="lists.sourceHeard" :state="validateState('sourceHeard')" aria-describedby="support-sourceheard-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-sourceheard-feedback">Select one.</b-form-invalid-feedback>
                    </b-form-group>

                    <transition name="fade" mode="out-in">
                      <div>
                        <b-alert v-model="error" key="error-box" show variant="danger" dismissible class="mt-2">
                          {{errorMsg}}
                        </b-alert>
                        <b-alert v-model="success" key="success-box" show variant="success" dismissible class="mt-2">
                          Account created.
                        </b-alert>
                      </div>
                    </transition>

                    <b-card v-if="!success" bg-variant="light" class="mb-2">
                      By clicking the Create Account button below you agree to the CE Pass Terms & Conditions.
                      <div class="text-center mt-2 mb-2">
                        <b-button type="submit" variant="info">Create Account</b-button>
                      </div>
                    </b-card>

                  </div>
                </b-col>
              </b-row>
            </b-form>
          </div>

        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

// URL paramas
// https://www.thepolyglotdeveloper.com/2017/11/pass-data-between-routes-vuejs-web-application/

import service from "@/service/service"
import utils from "@/utils/utils"

import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength, between, sameAs, helpers } from 'vuelidate/lib/validators'

// Allow alphanumeric and some special characters
const regexPwd = helpers.regex('regexPwd', /^[a-zA-Z0-9.!@#$%&*~:;?+=^_-]*$/)

// optional agdNumber validator
// https://vuelidate.js.org/#sub-optional-validator
// If provided - expecting number between 4 and 10 characters.
const optionalAgdNumber = (value) => !helpers.req(value) || (!isNaN(Number(value)) && value.length > 4 && value.length < 10)
const optionalAgdNumberDupe = function (value) {
    if (!helpers.req(value)) {  // optional
      return true
    }
    return service.validateAgdNumber(this.form.hash, value)
  }

// using props for url parameters
// https://www.youtube.com/watch?v=ESg0k2zdME4

export default {
  name: "Register",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: 'System error - contact tech support.',
      loading: false,
      busy: false,
      success: false,
      msg: 'Use this section to update your account profile.',
      rurl: '',
      lists: {
        jobTitles: [utils.initSelectArray()],
        titles: [utils.initSelectArray()],
        states: [utils.initSelectArray()],
        countries: [utils.initSelectArray()],
        gradYears: [  ],
        genders: ['F','M','O'],
        ageRanges: [utils.initSelectArray()],
        officeSizes: [utils.initSelectArray()],
        sourceHeard: [utils.initSelectArray()]   // used for reg only
      },
      isPhoneMobile: 'checked',
      form: {
        jobTitle: null,
        title: null,
        firstname: null,
        lastname: null,
        officeName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        country: 'US',
        phone: null,
        isPhoneMobile: true,
        email: null,
        username: null,
        password: null,
        password2: null,
        agdNumber: null,
        certYear: null,
        gender: null,
        ageRange: null,
        officeSize: null,
        sourceHeard: null
      }
    }
  },
  props: { },
  mixins: [validationMixin],
  validations: {
    form: {
      jobTitle: {
        required
      },
      title: {
        required
      },
      firstname: {
        required,
        minLength: minLength(2)
      },
      lastname: {
        required,
        minLength: minLength(2)
      },
      officeName: {
        required,
        minLength: minLength(4)
      },
      address: {
        required,
        minLength: minLength(2)
      },
      city: {
        required,
        minLength: minLength(2)
      },
      state: {
        required
      },
      zip: {
        required,
        minLength: minLength(5)
      },
      country: {
        required
      },
      phone: {
        required,
        minLength: minLength(10)
      },
      email: {
        required,
        email,
        isValid(value) {
          if (value === '') return true  // handled by required
          // service returns promise that resolves to true
          // if email can be used.
          return service.validateEmail('', value)
        }
      },
      username: {
        required,
        minLength: minLength(6),
        isValid(value) {
          if (value === '') return true  // handled by required
          // if ($v.form.username.$error) return true  ($v not defined.)

          // service returns promise that resolves to true
          // if username can be used.
          return service.validateUsername('', value)
        }
      },
      password: {
        required,
        minLength: minLength(6),
        regexPwd
      },
      password2: {
        sameAsPassword: sameAs('password')
      },
      agdNumber: {
        optionalAgdNumber,
        optionalAgdNumberDupe
      },
      certYear: {
        required
      },
      gender: {
        required
      },
      ageRange: {
        required
      },
      officeSize: {
        required
      },
      sourceHeard: {
        required
      }
    }
  },
  computed: {
    viewGender() {
      if(this.form.gender == 'M') return 'Male'
      if(this.form.gender == 'F') return 'Female'
      if(this.form.gender == 'O') return 'Other'
      return 'Select One'
    }
  },
  methods: {
    validateState(name) {
      // console.log(`name: ${name}`)
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null;
    },
    setUsername(value) {
      // can be used if input form uses @change
      this.form.username = value
      this.$v.form.username.$touch()
    },
    register(e) {

      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        console.log(`ERROR!!`)
        this.errorMsg = 'Correct errors and resubmit.'
        this.error = true
        return
      }

      this.form.isPhoneMobile = (this.isPhoneMobile === 'checked')

      this.error = false
      this.success = false
      this.busy = true
      service
        .register(this.form)
        .then( res => {
          if (this.debug) console.log(res.data)
          if (res.status && res.student && res.student.status) {
            let student = res.student
            // Login and go to smart redirect
            this.studentHash = res.hash;
            this.$root.setToken(student.hash); // logs student in
            this.$root.setStudentHash(student.hash)
            this.$root.setStudentName(student.title, student.firstname, student.lastname)
            this.$root.setStudentEmail(student.email)

            // Show success message 2 mins then go to rurl.
            window.setTimeout( (function () {
              console.log(`Forwarding to: ${this.rurl}`)
              this.$router.push({ path: this.rurl })
            }).bind(this), 2000)

            this.error = false
            this.success = true

            // TBD re-init whole form
            // this.form.username = ''
            // this.form.email = ''
            // this.form.password = ''

          } else {
              this.success = false
              this.errorMsg = res.errorMsg || 'System Error from Register Service.'
              this.error = true
          }
        })
        .finally( () => {
          this.busy = false
        })
        .catch(e => {
          console.log(e);
          this.busy = false
          this.error = true
        })
    },
    setCertYears() {
      const MIN_YEAR = (new Date).getFullYear() - 90  // 90 years ago
      const MAX_YEAR = (new Date).getFullYear() + 10  // future graduates
      this.lists.certYears = []
      for(let ix=MIN_YEAR; ix <= MAX_YEAR; ix++) {
        this.lists.certYears.push(ix.toString())
      }
    }
  },
  created() {
    this.setCertYears()
    this.rurl = this.$route.query.rurl || '/home'
    this.busy = true
    service
      .getAccountItems(null)
      .then(
        (res => {
          // console.log(`back from getAccountItems!`);
          if (this.debug) console.log(res);
          if (res.status) {
            this.lists.jobTitles = this.lists.jobTitles.concat(utils.prepSelectArray(res.jobTitles))
            this.lists.titles = this.lists.titles.concat(utils.prepSelectArray(res.titles))
            this.lists.states = this.lists.states.concat(res.states)
            this.lists.countries = this.lists.countries.concat(res.countries)
            this.lists.ageRanges = this.lists.ageRanges.concat(utils.prepSelectArray(res.ageRanges))
            this.lists.officeSizes = this.lists.officeSizes.concat(utils.prepSelectArray(res.officeSizes))
            this.lists.sourceHeard = this.lists.sourceHeard.concat(utils.prepSelectArray(res.sourceHeard))
          }
          else {
            this.error = true
          }
        }).bind(this)
      )
      .finally(e => {
        this.busy = false;
        console.log(`finally...`);
      })
      .catch(e => {
        this.error = true;
        console.log(e);
      })
  },
  mounted() { console.log('Register Mounted') },
  beforeDestroy() { console.log(`Register beforeDestroy`) }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Register.vue